import { Expose } from "class-transformer";

export class CreateSubcategoryDto {
  @Expose()
  name: string;

  @Expose()
  categoryId: string;
}
